interface paddingInterface {
  xs: string
  sm: string
  md: string
  lg: string
  xl: string
  '2xl': string
  '3xl': string
  '4xl': string
}
export default defineComponent({
  setup() {
    const paddings = ref<paddingInterface>({
      xs: 'md:p-2',
      sm: 'md:p-4',
      md: 'md:p-8',
      lg: 'md:p-12',
      xl: 'md:p-16',
      '2xl': 'md:p-20',
      '3xl': 'md:p-24',
      '4xl': 'md:p-28',
    })
    const mobilePaddings = ref<paddingInterface>({
      xs: 'p-2',
      sm: 'p-4',
      md: 'p-8',
      lg: 'p-12',
      xl: 'p-16',
      '2xl': 'p-20',
      '3xl': 'p-24',
      '4xl': 'p-28',
    })
    return {
      paddings,
      mobilePaddings,
    }
  },
})
